import { facebook, ga, adjust, pinterest } from 'js/analytics/adapters'

export const trackCompleteRegistration = ({ profile }) => {
  ga.track('Complete Registration')
  facebook.track('CompleteRegistration')
  adjust.track('Complete Registration', profile.id)
  pinterest.track('signup')
}
